/**
 * A prévia ao vivo do Chat (docs/spec/settings.md): duas falas de exemplo com as classes do chat de
 * verdade. O tamanho e o espaçamento vêm das variáveis do `<html>` (applyGlobalSettings), e o
 * Talemark lê as regras de formatação das preferências: mudar uma opção abaixo muda a prévia na hora.
 */
import { useT } from '../i18n/index.js';
import { TalemarkView } from '../room/Talemark.js';
import { useApp } from '../store.js';

function Time({ at }: { at: string }) {
  const show = useApp((s) => s.settings.showTimestamps);
  return show ? <span className="rd-chat__time">[{at}]</span> : null;
}

export function ChatPreview() {
  const t = useT();
  const bars = useApp((s) => s.settings.barNotices);
  return (
    <section className="rd-prefs__card rd-prefs__chatPreview" aria-labelledby="pref-chat-preview">
      <header className="rd-prefs__cardHead rd-prefs__cardHead--row">
        <h3 id="pref-chat-preview" className="rd-prefs__eyebrow">
          {t('prefs.chat.preview')}
        </h3>
        <span className="rd-prefs__desc">{t('prefs.chat.preview.hint')}</span>
      </header>
      <div className="rd-chat__log rd-prefs__chatLog">
        <div className="rd-chat__line">
          <Time at="21:04" /> <span className="rd-chat__name">{t('prefs.chat.preview.gm')}</span>
          <span className="rd-chat__colon">:</span>{' '}
          <span className="rd-chat__text">
            <TalemarkView text={t('config.text.sample')} />
          </span>
        </div>
        <div className="rd-chat__line rd-chat__line--action">
          <Time at="21:05" /> <span className="rd-chat__name">{t('prefs.chat.preview.player')}</span> <TalemarkView text={t('prefs.chat.preview.action')} inline />
        </div>
        {bars ? (
          <div className="rd-chat__line rd-chat__line--system">
            <Time at="21:05" /> <TalemarkView text={t('prefs.chat.preview.bar')} inline />
          </div>
        ) : null}
      </div>
    </section>
  );
}
